module.exports = __webpack_public_path__ + "static/present-148fbc1e7d223443b70f1b73efc0cb2d.jpg";